class AdditionQuestion extends React.Component {
  render() {
    return (<div className="form-group">
        <textarea name={this.props.questionValue} className="form-control" rows="3" placeholder="" onChange={this.props.handleChange(this.props.questionLabel, this.props.number, this.props.questionType)} required="required"></textarea>
    </div>)
  }

};


export default AdditionQuestion;



// WEBPACK FOOTER //
// in/js/components/additional-quest.js